import { HeroIcon } from '@components/HeroIcon'
import { Modal } from '@components/Modal'
import { Separator, Stack, XStack, YStack } from 'tamagui'
import { QualityOption } from '.'
import { ConfigItemText } from './ConfigsModal'
import { HeroRadio } from '@components/HeroRadio'
import { useWhenShouldModalAdapt } from '@hooks/useWhenShouldModalAdapt'
import { Pressable } from 'react-native'

interface IQualitySelectorProps {
  open: boolean
  onClose: () => void
  qualityOptions: QualityOption[]
  onQualityChange: (quality: QualityOption) => void
  currentQuality: QualityOption
}
export function QualitySelector({
  open,
  onClose,
  qualityOptions,
  onQualityChange,
  currentQuality,
}: IQualitySelectorProps) {
  const { whenShouldAdapt } = useWhenShouldModalAdapt()
  const handleValueChange = (value: string) => {
    if (value === 'Automático') {
      onQualityChange(qualityOptions[0])
    }
    const qualityOption = qualityOptions.find(
      (qualityOption) => qualityOption.label === value,
    )
    if (qualityOption) {
      onQualityChange(qualityOption)
    }
  }
  return (
    <Modal
      onClose={onClose}
      open={open}
      snapPointsMode="fit"
      backdropOpacity={0.9}
      whenShouldAdapt={whenShouldAdapt ?? 'sm'}
    >
      <XStack
        gap="$spacing-inset-nano"
        alignItems="center"
        p="$spacing-inset-md"
        justifyContent="center"
      >
        <HeroIcon icon={['fal', 'sliders']} color="$icon-primary" size={24} />
        <ConfigItemText>Qualidade</ConfigItemText>
      </XStack>
      <Separator
        borderColor="$border-strong"
        borderWidth="$border-width-hairline"
      />
      <YStack gap="$spacing-inset-sm" padding="$spacing-inset-md">
        {qualityOptions.map((qualityOption) => (
          <Stack key={qualityOption.label}>
            <Pressable
              key={qualityOption.label}
              style={{
                backgroundColor: 'transparent',
                zIndex: 2,
                width: 100,
                height: '100%',
                position: 'absolute',
              }}
              onPressIn={() => handleValueChange(qualityOption.label)}
            />
            <HeroRadio
              size={29}
              options={[
                {
                  name: qualityOption.label,
                  value: qualityOption.label,
                },
              ]}
              labelStyle={{
                fontFamily: '$mulishBold',
                fontSize: '$font-size-xs',
                fontWeight: 700,
              }}
              style={{
                zIndex: 1,
              }}
              value={currentQuality.label}
            />
          </Stack>
        ))}
      </YStack>
    </Modal>
  )
}
